import callApi from 'services/api'
import React, { useEffect, useState, useCallback } from 'react'
import debounce from 'lodash.debounce'
import AddMasterData from './AddMasterData'
import {
  faEdit,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import TabLayout from './TabLayout'

import { useSetRecoilState } from 'recoil'
import { loadingState } from 'global/LoaderState'
import Modal from 'utils/Modal'

const MasterData = () => {
  const [filters, setFilters] = useState([])
  const [list, setList] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [selected, setSelected] = useState(null)
  const loader = useSetRecoilState(loadingState)
  const [filterType, setFilterType] = useState("unit")

  const [showModal, setShowModal] = useState(false)
  const [editingData, setEditingData] = useState(null)
  const [currentPage, setCurrentPage] = useState(1)
  const [totalPages, setTotalPages] = useState(1)
  const [totalRecords, setTotalRecords] = useState(0)
  const limit = 10


  const getMasterList = async () => {
    try {
      setLoading(true)
      setError(null)

      const response = await callApi(
        `config/`,
        'GET',
        null,
        true,
        true,
        (msg) => setError(msg),
        (path) => console.log('navigate to', path)
      )

      if (response.success) {
        const options = Object.keys(response.body).map((key) => {
          const item = response.body[key]

          return {
            id: key,
            value: key
              .replace(/_/g, ' ')
              .replace(/\b\w/g, (c) => c.toUpperCase()),
            hasParent: item.parent_filter ? true : false,
            parent_filter: item.parent_filter || [],
          }
        })

        setFilters(options)
      }
    } catch (err) {
      setError(err.message || 'Failed to load filters')
    } finally {
      setLoading(false)
    }
  }

  const getList = async (value = filterType, page = 1) => {
    try {
      loader(true)
      if (!value) {
        setList([])
        return
      }

      const params = new URLSearchParams({
        filter: JSON.stringify({ type: value }),
        sort_order: '1',
        page: page.toString(),
        limit: limit.toString(),
      })

      const response = await callApi(
        `filtermaster?${params}`,
        'GET',
        null,
        true,
        true,
        (msg) => setError(msg),
        (path) => console.log('navigate to', path)
      )

      if (response.success) {
        const body = response?.body || {}
        setList(body.data)
        setCurrentPage(body.current_page || 1)
        setTotalPages(body.total_pages || 1)
        setTotalRecords(body.total_count || 0)

      }
    } catch (error) {
    } finally {
      loader(false)
    }
  }



  // const debouncedGetList = useCallback(
  //   debounce((value) => getList(value), 300),
  //   []
  // )

  const handleChange = (e) => {
    const value = e.target.value
    setFilterType(value)
    // debouncedGetList(value)


    const option = filters.find((f) => f.id === value)
    setSelected(option)
  }

  useEffect(() => {
    getMasterList()
    getList("unit", 1)
  }, [])



  const handleOpenModal = (data = null) => {
    setEditingData(data)
    setShowModal(true)
  }

  const handleCloseModal = () => {
    setEditingData(null)
    setShowModal(false)
  }

  const renderRows = () => {
    if (!list?.length) {
      return (
        <table className="table">
          <thead>
            <tr>
              <td colSpan={4} className="p-3 text-start">
                No Data
              </td>
            </tr>
          </thead>
        </table>
      )
    }

    // Format parent column header
    const parentHeader =
      selected?.hasParent && selected?.parent_filter?.length
        ? selected.parent_filter[0]
          .replace(/_/g, " ")
          .replace(/\b\w/g, (c) => c.toUpperCase())
        : null

    return (
      <table className="table table-striped">
        <thead>
          <tr>
            <th>Name</th>
            <th>Description</th>

            {parentHeader && <th>{parentHeader}</th>}

            <th>Actions</th>
          </tr>
        </thead>

        <tbody>
          {list.map((item) => (
            <tr key={item.id}>
              <td>{item.name}</td>
              <td>{item.description || "-"}</td>

              {parentHeader && <td>{item.parent?.name ?? "-"}</td>}

              <td>
                <button
                  type="button"
                  onClick={() => handleOpenModal(item)}
                  className="btn btn-sm btn-link me-2"
                  style={{ textDecoration: "none" }}
                >
                  <FontAwesomeIcon icon={faEdit} className="me-1" />
                  Edit
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    )
  }

  return (
    <div>
      <div className="ms-3 me-3 mt-3 d-flex justify-content-between bg-dark rounded ">
        <h5 className="card-title  p-3 m-0 text-white">Master Data</h5>
        {selected ? (
          <button
            className="btn secondary me-1 mb-1 text-white "
            onClick={() => handleOpenModal()}
          >
            <FontAwesomeIcon icon={faEdit} className="me-1" /> Add{' '}
            {selected?.value}
          </button>
        ) : null}
      </div>
      <div className="card-body ms-3">
        <div className="d-flex">
          <div style={{ margin: '0.5rem 0' }}>
            <TabLayout filters={filters} handleChange={handleChange} />
          </div>
          {loading && <div>Loading...</div>}
          {error && <div className="text-danger">{error}</div>}


          <div className="table-responsive tab-content flex-grow-1">
            {renderRows()}
          </div>
        </div>
        <div className="d-flex justify-content-between align-items-center mt-3">

          <div>
            Page {currentPage} of {totalPages} | Total Records: {totalRecords}
          </div>

          <div>
            <button
              disabled={currentPage === 1}
              onClick={() => getList(filterType, currentPage - 1)}
              className="btn btn-sm btn-outline-primary me-2"
            >
              Previous
            </button>

            <button
              disabled={currentPage === totalPages}
              onClick={() => getList(filterType, currentPage + 1)}
              className="btn btn-sm btn-outline-primary"
            >
              Next
            </button>
          </div>

        </div>
        <>
          {/* <select
            name="filterType"
            className="form-control"
            id="filterType"
            style={{ width: '50%', margin: '2rem 0' }}
            onChange={handleChange}
            disabled={loading}
          >
            <option value="">Select an option...</option>
            {filters.map((option) => (
              <option key={option.id} value={option.id}>
                {option.value}
              </option>
            ))}
          </select> */}
        </>
        <Modal
          showModal={showModal}
          modalWidth={{ width: '600px' }}
          handleCloseModal={handleCloseModal}
          title={
            editingData
              ? `Update${selected?.value ? ` ${selected?.value}` : ''}`
              : `Add${selected?.value ? ` ${selected?.value}` : ''}`
          }
        >
          <AddMasterData
            selected={selected}
            editingData={editingData}
            fetchList={getList}
            handleCloseModal={handleCloseModal}
            selectedName={selected?.value}
          />
        </Modal>
      </div>
    </div>
  )
}

export default MasterData
